import { render, staticRenderFns } from "./bill-details-repeater.vue?vue&type=template&id=5807e5e2&scoped=true&"
import script from "./bill-details-repeater.vue?vue&type=script&lang=js&"
export * from "./bill-details-repeater.vue?vue&type=script&lang=js&"
import style0 from "./bill-details-repeater.vue?vue&type=style&index=0&id=5807e5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807e5e2",
  null
  
)

export default component.exports